import { ReactElement, useEffect, useState } from 'react';
import {
  VideoImageSlideSt,
  VideoPlayerSt,
  VideoSlideContainerSt,
  VideoSlideIconSt,
  VideoPlayerContainerSt,
} from './VideoSlide.css';
import { usePlayMedia } from 'app/providers/PlayVideoProvider';
import { trackAction } from 'app/utils/tracking';
import { Play } from '@heycar-uikit/icons';

interface IVideoSlideProps {
  src?: string;
  type?: string;
  isPaused?: boolean;
  setIsPlaying?: (value: boolean) => void;
  isPlaying?: boolean;
  previewSrc?: string;
}

const VideoSlide = ({
  src,
  type,
  isPaused,
  setIsPlaying,
  previewSrc,
  isPlaying,
}: IVideoSlideProps): ReactElement => {
  const [player, setPlayer] = useState<any>();
  const [playOnInit, setPlayOnInit] = useState(false);
  const { fullScreenAndPlay } = usePlayMedia();

  const onPlay = () => {
    const currentTimeOnPlay = player && player.currentTime();

    trackAction('vehicle_video_on_play', {
      category: 'PDP',
      description: 'User starts playing video',
      value: Math.floor(currentTimeOnPlay),
    });
    setIsPlaying(true);
  };
  const onPause = () => {
    const currentTimeOnPause = player && player.currentTime();

    trackAction('vehicle_video_on_pause', {
      category: 'PDP',
      description: 'User clicks on pause',
      value: Math.floor(currentTimeOnPause),
    });
    setIsPlaying(false);
  };

  const startPlayingVideo = () => {
    setIsPlaying(true);
  };

  useEffect(() => {
    if (isPlaying && player) {
      player.play();
    }
  }, [player, isPlaying]);

  useEffect(() => {
    if (fullScreenAndPlay && !playOnInit) {
      setIsPlaying(true);
      setPlayOnInit(true);
    }
  }, []);

  useEffect(() => {
    if (player) {
      player.on('play', onPlay);
      player.on('pause', onPause);
    }
    return () => {
      if (player) {
        player.off('play', onPlay);
        player.off('pause', onPause);
      }
    };
  }, [player]);

  return (
    <VideoPlayerContainerSt onClick={startPlayingVideo}>
      <VideoPlayerSt
        show={isPlaying}
        options={{
          controls: true,
          responsive: true,
          fill: true,
          sources: [
            {
              src,
              type,
            },
          ],
          isPaused,
        }}
        onReady={player => setPlayer(player)}
      />
      {!isPlaying && (
        <VideoSlideContainerSt>
          <VideoImageSlideSt src={previewSrc} />
          <VideoSlideIconSt>
            <Play />
          </VideoSlideIconSt>
        </VideoSlideContainerSt>
      )}
    </VideoPlayerContainerSt>
  );
};

export default VideoSlide;
